import { storageName } from "../config";

export const formSubmissionDateTime = storageName + '-submissionDatetime';

export function isToday(date) {

	const subDate = new Date(date),
	  today = new Date(),
	  isSameDay = subDate.getMonth() === today.getMonth() && subDate.getFullYear() === today.getFullYear() && subDate.getDate() === today.getDate();

	return isSameDay;
}

export function hasSubmittedToday() {
	return isToday(getSubmissionDatetimeFromStorage());
}

export function getJsonDataFromStorage() {
	return JSON.parse(window.localStorage.getItem(storageName));
}

export function setJsonDataToStorage(data) {
	window.localStorage.setItem(storageName,JSON.stringify(data));
}

export function setSubmissionDatetimeToStorage(datetimeStr) {
	window.localStorage.setItem(formSubmissionDateTime, datetimeStr);
}

export function getSubmissionDatetimeFromStorage() {
	return window.localStorage.getItem(formSubmissionDateTime);
}